module.exports = __webpack_public_path__ + "img/Input.dc0e88f4.png";